import { Box, Paper, Typography } from "@mui/material";
import { tokens } from "../../theme";
import ActorTab from "../../components/authenticate/ActorTab";
import { observer } from "mobx-react-lite";

export default observer(function Login() {
  const colors = tokens();

  return (
    <div className="login-container">
      <div className="login-container_left"></div>
      <div className="login-container_right">
        <Paper className="login-paper">
          <Box
            sx={{
              mb: 2,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                color: `${colors.blue[300]}`,
                fontWeight: "bold",
                fontSize: "2rem",
                textAlign: "center",
              }}
            >
              Login
            </Typography>
          </Box>

          <ActorTab />
        </Paper>
      </div>
    </div>
  );
});
